import PlaceholderProfilePic from './PlaceholderProfilePic'

export default PlaceholderProfilePic
